'use client'

import { useTranslations } from 'next-intl'
import { useSelectedLayoutSegment } from 'next/navigation'

import { Link } from '@/i18n'
import { ROUTES } from '@/shared/config'

export const NavigationTabs = () => {
  const t = useTranslations('rating.tabs')
  const segment = useSelectedLayoutSegment()

  const tabs = [
    { label: t('players'), href: ROUTES.RATING_PLAYERS, value: 'players' },
    { label: t('teams'), href: ROUTES.RATING_TEAMS, value: 'teams' },
  ]

  return (
    <div className="flex flex-col sm:gap-4 custom:gap-10">
      <div className="flex gap-6 sm:gap-10">
        {tabs.map((tab) => {
          const isActive = segment === tab.value
          return (
            <Link
              key={tab.value}
              href={tab.href}
              className={`relative pb-3 font-bold transition-colors ${
                isActive ? 'text-white' : 'text-white/50'
              }`}
            >
              {tab.label}
              <div
                className={`absolute bottom-0 left-0 w-full h-[3px] bg-primary transition-all 
                ${isActive ? 'scale-x-100' : 'scale-x-0'}
            `}
              />
            </Link>
          )
        })}
      </div>
    </div>
  )
}
